import { FC, ReactNode } from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { CLICK_EVENT_PAYLOAD } from '../../utilities/analytics/analyticsGenericEvents';
import { useBreakpoint } from '../misc/Breakpoints/Breakpoints';
import { Slider } from '../slider/Slider';

import Texts from './text/howTo.json';
import { StepItem, Steps } from './Steps';

import styles from './StepsSection.scss';

const T = new MDText(Texts);

type StepsSectionProps = {
  analyticsConfig?: CLICK_EVENT_PAYLOAD;
  config: StepItem[];
  isAffiliate?: boolean;
  sliderClassName?: string;
  stepsClassName?: string;
  title?: ReactNode;
};

export const StepsSection: FC<StepsSectionProps> = ({
  analyticsConfig,
  config,
  isAffiliate = false,
  sliderClassName,
  stepsClassName,
  title = `${T.translate('title')}`,
}) => {
  const breakpoints = useBreakpoint();
  const contentBreakpoint = breakpoints.minWidth.breakpointContent;

  const renderContent = () => {
    if (contentBreakpoint) {
      return (
        <Steps
          className={stepsClassName}
          config={config}
        />
      );
    }

    return (
      <Slider
        analyticsConfig={analyticsConfig}
        className={cx(sliderClassName, {
          [stepsClassName as string]: isAffiliate,
        })}
        config={config}
      />
    );
  };

  return (
    <div className={styles.stepsSection}>
      <h2 className={cx('mw-title-title2', styles.title)}>
        {title}
      </h2>
      {renderContent()}
    </div>
  );
};
